import landscape from './pro/landscape';
import portrait from './pro/portrait';
import square from './pro/square';
import init from './cover_template.json';

export default {
  landscape,
  portrait,
  square,
  init,
};



// WEBPACK FOOTER //
// ./src/config/templates/covers/pro.jsx